import { getAxiosClient } from "../../../services/HttpsService";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchProcessInstances = createAsyncThunk(
  "monitor/fetchProcessInstances",
  async (params: {
    monitorPageNumber: number;
    rowsPerPage: number;
    filters: {
      search?: string;
      status?: string[];
      startedBy?: string;
      timeRange?: string;
      processCreatedBy?: string;
    };
  }) => {
    const { monitorPageNumber, rowsPerPage, filters } = params;
    const client = getAxiosClient();

    const statusFilters = filters.status || [];

    const response = await client.get("api/process-instance-details/filtered", {
      params: {
        page: monitorPageNumber,
        size: rowsPerPage,
        search: filters.search,
        isActive: statusFilters.includes("active") ? "true" : undefined,
        inProgress: statusFilters.includes("inProgress") ? "true" : undefined,
        completed: statusFilters.includes("completed") ? "true" : undefined,
        startedBy: filters.startedBy,
        timeRange: filters.timeRange,
        processCreatedBy: filters.processCreatedBy,
      },
    });

    return response.data;
  }
);

export const triggerProcessExecution = createAsyncThunk(
  "process/triggerProcessExecution",
  async (params: { processId: string; instanceId: string }) => {
    const { processId, instanceId } = params;
    const client = getAxiosClient();
    const response = await client.get(`/main/process-execution`, {
      params: {
        processId,
        instanceId,
      },
    });
    return response.data;
  }
);

export const fetchProcessInstanceByUuid = createAsyncThunk(
  "monitor/fetchProcessInstance",
  async (params: { uuid: string }) => {
    const { uuid } = params;
    const client = getAxiosClient();
    const response = await client.get(
      `api/eza_app_process_instance/uuid/${uuid}`
    );
    return response.data;
  }
);
